import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import '../../css/performance-selector.css';

const ProductPerformanceSelector = ({
  performances,
  selectedPerformance,
  onSelect,
  selectedIndex,
}) => {
  const [visiblePerformances, setVisiblePerformances] = useState(performances);
  const prevSelectedIndexRef = useRef();

  useEffect(() => {
    setVisiblePerformances(performances);
    prevSelectedIndexRef.current = selectedIndex;
  }, [performances, selectedPerformance]);

  return (
    <div className={`performance-selector row`}>
      {visiblePerformances
        .map((performance, i) => {

          const performanceText = format(performance.time, 'HH:mm');
          const isDisabled = performance.soldOut;
          const isSelected = selectedPerformance === performanceText;

          return (
            <div className='col-3 pb-3' key={i}>
              <button
                className={`btn show-time-btn ${isDisabled ? 'disabled-performance' : ''} ${
                  isSelected ? 'font-weight-normal selected-performance' : ''
                }`}
                onClick={() => onSelect(performanceText)}
                disabled={isDisabled}
              >
                {performance ? performanceText : ''}
              </button>
            </div>
          );
        })}
    </div>
  );
};

export default ProductPerformanceSelector;
